import React, { useEffect, useState, useRef } from 'react'
import classNames from 'classnames'

import style from './TmoDropDownSelect.module.css'

function TmoDropDownSelect({
  optionsList,
  onChange,
  renderIcon,
  iconClass,
  defaultSelectedValue,
  formMargin,
  id
}) {
  const [selectState, setSelectState] = useState(false)
  const [selectedIndex, setSelectedIndex] = useState(0)
  const [selectedValue, setSelectedValue] = useState(
    defaultSelectedValue && defaultSelectedValue.key
  )
  const [selectedText, setSelectedText] = useState(
    defaultSelectedValue && defaultSelectedValue.value
  )
  const node = useRef()
  const listBox = useRef()
  const handleOptionClick = (e) => {
    let key = e?.target ? e?.target?.getAttribute('data-name') : ''
    let value = e?.target ? e?.target?.getAttribute('data-value') : ''
    value && setSelectedText(value)
    key && setSelectedValue(key)
    key && onChange(key, selectedValue)
    setSelectState(!selectState)
    setSelectedIndex(0)
  }

  const handleClickOutside = (e) => {
    if (node.current.contains(e.target)) {
      return
    }
    setSelectState(false)
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])
  const handleKeyDown = (event) => {
    if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
      event.preventDefault()
      const listItems = listBox.current.querySelectorAll('[role="option"]')
      if (listItems.length > 0) {
        let newIndex
        if (event.key === 'ArrowDown') {
          newIndex = Math.min(selectedIndex + 1, listItems.length - 1)
        } else {
          newIndex = Math.max(selectedIndex - 1, 0)
        }
        listItems[newIndex].focus()
        setSelectedIndex(newIndex)
      }
    } else if (event.key === 'Enter') {
      const focusedOption = document.activeElement
      if (focusedOption && focusedOption.getAttribute('role') === 'option') {
        const button = focusedOption.querySelector('button')
        if (button) {
          button.click()
        } else {
          handleOptionClick(event)
        }
      }
    }
  }
  return (
    <div
      ref={node}
      className={classNames(style.select, formMargin && style.form_margin)}
    >
      <div
        className={classNames(
          style.select_input,
          selectedText && style.selected_text
        )}
        onClick={() => {
          setSelectState(!selectState)
        }}
        role='combobox'
        aria-expanded={selectState.toString()}
        aria-controls='combobox'
        aria-haspopup='listbox'
        value='Select'
        tabindex='0'
        aria-labelledby={id}
        tabIndex={0}
        onKeyDown={handleKeyDown}
      >
        {selectedText ? selectedText : 'Select'}
        <span className={classNames(style.icon, iconClass)}>{renderIcon}</span>
      </div>
      {selectState && (
        <div className={style.select_list}  role='listbox'
          id='listbox'
          aria-label='Select Options'
          aria-labelledby={id}
          tabIndex={0}
          ref={listBox}>
          {optionsList?.length > 0 &&
            optionsList.map((e, index) => (
              <div
                className={classNames(
                  style.option_list,
                  e.key == selectedValue && style.selected
                )}
                data-name={e.key}
                data-value={e.value}
                key={`${e.key}-${index}`}
                title={e.value}
                aria-label={e.value}
                id='listbox'
                aria-labelledby={id}
                aria-selected={e.value === selectedValue}
                tabIndex={index + 2}
                onClick={(e) => handleOptionClick(e)}
                onKeyDown={handleKeyDown}
                role='option'
              >
                {e.value}
              </div>
            ))}
        </div>
      )}
    </div>
  )
}

export default TmoDropDownSelect
